import React from 'react';
import { translate } from 'react-i18next';
import { createRoute } from 'lib/util';
import * as Common from 'common/components';

const { Form } = Common;

const EmployeesListHeader = ({ canAdd = false, companyId = '', subcompanyId = '', t }) => {
  return (
    <Common.Header title={t('custom_fields_employees.title')}>
      <div className="btn-group pull-right">
        {canAdd && (
          <Form.Link
            to={createRoute(companyId, subcompanyId, 'custom_fields_employees/add')}
            className="btn btn-info"
          >
            {t('actions.add')}
          </Form.Link>
        )}
      </div>
    </Common.Header>
  );
};

export default translate()(EmployeesListHeader);



// WEBPACK FOOTER //
// src/modules/secured/modules/custom_fields_employees/components/list/EmployeesListHeader.js